import { observable, action, computed } from "mobx";
let classInfo = [
    {
        className: "泄泻",
        className_ed: "腹泻",
        classType: ["肝气乘脾", "肝郁乘脾"],
        mainPosition: ["大肠俞", "天枢", "上巨虚", "三阴交", "神阙"],
        minorPosition: ["期门", "太冲"],
        posInfo: [
            {
                posName: "大肠俞",
                spellName: "dachangyu",
                aiJiuFlag: 0,
                jinZhenType: 4,
                zhenType: 1.5,
                thornType: 0,
                xzType: 2,
                xzType_nd: 3,
                lieType: 1,
                disinfectionType: 0,
                unitInterval: [0.2, 1.2],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/dachangyu.mp3")
            },
            {

                posName: "天枢",
                spellName: "tianshu",
                aiJiuFlag: 0,
                jinZhenType: 0,
                zhenType: 1.5,
                thornType: 0,
                xzType: 0,
                xzType_nd: 0,
                lieType: 0,
                disinfectionType: 0,
                unitInterval: [1, 1.2],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/tianshu.mp3")
            },
            {
                posName: "上巨虚",
                spellName: "shangjuxu",
                aiJiuFlag: 0,
                jinZhenType: 1,
                zhenType: 1.5,
                thornType: 0,
                xzType: 1,
                xzType_nd: 1,
                lieType: 0,
                disinfectionType: 0,
                unitInterval: [1.2, 1.5],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/shangjuxu.mp3")
            },
            {
                posName: "三阴交",
                spellName: "sanyinjiao",
                aiJiuFlag: 0,
                jinZhenType: 1,
                zhenType: 1.5,
                thornType: 0,
                xzType: 0,
                xzType_nd: 0,
                lieType: 0,
                disinfectionType: 0,
                unitInterval: [1, 1.2],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/sanyinjiao.mp3")
            },
            {
                posName: "期门",
                spellName: "qimen",
                aiJiuFlag: 0,
                jinZhenType: 1,
                zhenType: 1,
                thornType: 1,
                xzType: 2,
                xzType_nd: 4,
                lieType: 0,
                disinfectionType: 0,
                unitInterval: [0.5, 0.8],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/qimen.mp3")
            },
            {
                posName: "太冲",
                spellName: "taichong",
                aiJiuFlag: 0,
                jinZhenType: 4,
                zhenType: 1,
                thornType: 1,
                xzType: 2,
                xzType_nd: 4,
                lieType: 0,
                disinfectionType: 0,
                unitInterval: [0.5, 0.8],
                totalScore: 11,
                audio: require("../assets/audio/xuewei/taichong.mp3")
            },
            {
                posName: "神阙",
                spellName: "shenque",
                aiJiuFlag: 1,
                totalScore: 5.5,
                audio: require("../assets/audio/xuewei/shenque.mp3")
            }
        ],
        tipsData: [
            { tips: "中医病名：泄泻<br/>辩证分型：肝气乘脾" },
            { tips: "主穴：大肠俞、天枢、上巨虚、三阴交、神阙<br/>配穴：期门、太冲" },
            {
                tips: "消毒先后顺序：先患者皮肤消毒，再进行操作者手指消毒<br/>针灸方法：<br/>大肠俞：俯卧位；1.5寸毫针；单手进针法；直刺；刺入0.2寸 - 1.2 寸，捻转补泻，捻转泻法。<br/>     天枢：仰卧位；1.5寸毫针；舒张进针法；直刺；刺入1寸- 1.2寸，平补平泻。<br/>上巨虚：仰卧位；1.5寸毫针；指切进针法；直刺；刺入1.2寸 - 1.5寸，提插补泻，提插补法。<br/>        三阴交：仰卧位；1.5寸毫针；指切进针法；直刺；刺入1寸 - 1.2寸，平补平泻。<br/>        期门：仰卧位；1寸毫针；指切进针法；斜刺；刺入0.5寸 - 0.8寸，捻转补泻，捻转泻法。<br/>  太冲：仰卧位；1寸毫针；单手进针法；斜刺；刺入0.5寸 - 0.8寸，捻转补泻，捻转泻法。<br/> 神阙：温灸盒灸；询问患者温度。<br/>治疗时间：<br/> 留针时间：20-30分钟<br/>艾灸时间：20-30分钟"
            },
            { tips: "出针顺序：大肠俞、期门、天枢、上巨虚、三阴交、太冲" },
            { tips: "锐器垃圾桶：针<br/>医疗废物：棉球、棉签" }

        ]
    }
]



class Score {
    @observable studyType = false;
    @observable score = 0;
    @observable classInfo = classInfo[0];
    // @observable userInput = ["大肠俞", "天枢", "上巨虚", "三阴交", "神阙"];
    @observable userInput = [];
    
    @observable penalties = [];
    @action.bound setType(bool) {
        this.studyType = bool;
    }
    @action.bound setClass(index) {
        this.classInfo = classInfo[index]
    }
    @action.bound addScore(score) {
        this.score = this.score + score
    }
    @action.bound recordInput(posName) {
        this.userInput.push(posName)
    }
    @action.bound setInput(arr) {
        this.userInput = arr
    }
    @action.bound clearUserInput(posName) {
        this.userInput = []
    }
    @action.bound reStart() {
        this.userInput = [];
        this.score = 0;
        this.penalties = [];
    }
    @action.bound setPenalties(name, score) {
        let penalties = this.penalties;
        if (penalties.length > 0) {
            let hasName = false;
            for (let i = 0; i < penalties.length; i++) {
                if (penalties[i].name == name) {
                    penalties[i].score = penalties[i].score + score
                    hasName = true;
                    break;
                }
            }
            if (!hasName) {
                let obj = {
                    name, score
                }
                penalties.push(obj);
            }
        }
        else {
            let obj = {
                name, score
            }
            penalties.push(obj);
        }
        this.penalties = penalties;
    }

}

export default new Score();

